import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

type Props = {
  button: (onClick: () => void) => React.ReactElement;
  dialogTitle: string;
  dialogText: string;
  dialogConfirmText: string;
  onCancel?: () => void;
  onConfirm: () => Promise<void>;
};

function ConfirmationDialog(props: Props) {
  const { button, dialogTitle, dialogText, dialogConfirmText, onCancel, onConfirm } = props;

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {button(() => {
        handleClickOpen();
      })}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>{dialogText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(event) => {
              event.stopPropagation();
              if (onCancel != null) {
                onCancel();
              }
              handleClose();
            }}
          >
            Abbrechen
          </Button>
          <Button
            onClick={async (event) => {
              event.stopPropagation();
              await onConfirm();
              handleClose();
            }}
            autoFocus
          >
            {dialogConfirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConfirmationDialog;
